import { useState } from 'react'
import { BaseModal } from './BaseModal'
import { CtaStep } from './plus/CtaStep'
import { RegistrationStep } from './plus/RegistrationStep'
import { fb } from '../../lib/firebase'
import { User } from '../../lib/user'
import { Plan } from '../../lib/plans'

type Props = {
  user: User
  isOpen: boolean
  handleClose: (plan?: Plan) => void
}

export const PlusSignupModal = ({ user, isOpen, handleClose }: Props) => {
  // TODO reset index when dismissed
  const [stepIndex, setStepIndex] = useState(0);
  const [plan, setPlan] = useState<Plan|null>(null)

  const onClose = (plan?: Plan) => {
    setStepIndex(0);
    handleClose(plan);
  }

  // TODO handle browser fwd/bck buttons
  const onPlanSelect = (plan: Plan) => {
    const skip = fb.isSignedIn() ? 2: 1
    setPlan(plan)
    const index = stepIndex + skip
    if(index === 2) {
      onClose(plan)
      return
    }
    setStepIndex(index)
  }


  const getStep = () => {
    switch(stepIndex) {
      case 0:
        return (<CtaStep onPlanSelect={onPlanSelect} />)
      case 1:
        if(!plan) {
          throw new Error('plan unset')
        }
        return (<RegistrationStep plan={plan}/>)
      default:
        throw new Error('reached unknown step')
    }
  }
 
  return (
    <BaseModal title="" isOpen={isOpen} handleClose={onClose}>
      {getStep()}
    </BaseModal>
		)
}
